import React, { ReactNode } from 'react';

import cn from 'classnames';

import Icon from '@components/Icon';

import styles from './index.module.less';

interface ItemProps {
  time: string;
  content: ReactNode;
  contentContainerClassName?: string;
}

interface TimelineProps {
  items: ItemProps[];
  contentContainerClassName?: string;
}

export const Item: React.FC<ItemProps> = (props) => {
  const { time = '2022 / 10', content, contentContainerClassName } = props;
  return (
    <div className={styles.itemContainer}>
      <div className={styles.header}>
        <div>
          <Icon name="theCircle" className={styles.icon} />
          <span className={cn(styles.time, 'DINPro')}>{time}</span>
        </div>
        <div className={styles.line} />
      </div>
      <div className={cn(styles.main, contentContainerClassName)}>
        {content}
      </div>
    </div>
  );
};

export const Timeline: React.FC<TimelineProps> = (props) => {
  const { items = [], contentContainerClassName } = props;
  return (
    <div>
      {items.map((i, index) => {
        return (
          <Item
            key={index}
            {...i}
            contentContainerClassName={contentContainerClassName}
          />
        );
      })}
    </div>
  );
};
